export const countries = [
  { label: 'Ελλάδα', value: 'Ελλάδα' },
  { label: 'Αγία Λουκία', value: 'Αγία Λουκία' },
  { label: 'Άγιος Βαρθολομαίος', value: 'Άγιος Βαρθολομαίος' },
  { label: 'Άγιος Μαρτίνος (Γαλλία)', value: 'Άγιος Μαρτίνος (Γαλλία)' },
  { label: 'Άγιος Μαρτίνος (Ολλανδία)', value: 'Άγιος Μαρτίνος (Ολλανδία)' },
  {
    label: 'Άγιος Βικέντιος και Γρεναδίνες',
    value: 'Άγιος Βικέντιος και Γρεναδίνες',
  },
  { label: 'Άγιος Μαρίνος', value: 'Άγιος Μαρίνος' },

  { label: 'Σαιν Πιερ και Μικελόν', value: 'Σαιν Πιερ και Μικελόν' },
  {
    label: 'Άγιος Χριστόφορος και Νέβις',
    value: 'Άγιος Χριστόφορος και Νέβις',
  },
  { label: 'Αζερμπαϊτζάν', value: 'Αζερμπαϊτζάν' },
  { label: 'Αίγυπτος', value: 'Αίγυπτος' },
  { label: 'Αιθιοπία', value: 'Αιθιοπία' },
  { label: 'Αϊτή', value: 'Αϊτή' },
  { label: 'Ακτή Ελεφαντοστού', value: 'Ακτή Ελεφαντοστού' },
  { label: 'Αλβανία', value: 'Αλβανία' },
  { label: 'Αλγερία', value: 'Αλγερία' },
  { label: 'Αμερικανική Σαμόα', value: 'Αμερικανική Σαμόα' },
  { label: 'Ανατολικό Τιμόρ', value: 'Ανατολικό Τιμόρ' },
  { label: 'Ανγκόλα', value: 'Ανγκόλα' },
  { label: 'Ανγκουίλα', value: 'Ανγκουίλα' },
  { label: 'Ανδόρρα', value: 'Ανδόρρα' },
  { label: 'Ανταρκτική', value: 'Ανταρκτική' },
  { label: 'Αντίγκουα και Μπαρμπούντα', value: 'Αντίγκουα και Μπαρμπούντα' },
  { label: 'Αργεντινή', value: 'Αργεντινή' },
  { label: 'Αρμενία', value: 'Αρμενία' },
  { label: 'Αρούμπα', value: 'Αρούμπα' },
  { label: 'Αυστραλία', value: 'Αυστραλία' },
  { label: 'Αυστρία', value: 'Αυστρία' },
  { label: 'Αφγανιστάν', value: 'Αφγανιστάν' },
  { label: 'Βανουάτου', value: 'Βανουάτου' },
  { label: 'Βατικανό', value: 'Βατικανό' },
  { label: 'Βέλγιο', value: 'Βέλγιο' },
  { label: 'Βενεζουέλα', value: 'Βενεζουέλα' },
  { label: 'Βερμούδες', value: 'Βερμούδες' },
  { label: 'Βιετνάμ', value: 'Βιετνάμ' },
  { label: 'Βολιβία', value: 'Βολιβία' },
  { label: 'Βόρεια Κορέα', value: 'Βόρεια Κορέα' },
  { label: 'Βοσνία-Ερζεγοβίνη', value: 'Βοσνία-Ερζεγοβίνη' },
  { label: 'Βουλγαρία', value: 'Βουλγαρία' },
  { label: 'Βραζιλία', value: 'Βραζιλία' },
  {
    label: 'Βρετανικό Έδαφος Ινδικού Ωκεανού',
    value: 'Βρετανικό Έδαφος Ινδικού Ωκεανού',
  },
  { label: 'Βρετανικές Παρθένοι Νήσοι', value: 'Βρετανικές Παρθένοι Νήσοι' },
  { label: 'Γαλλία', value: 'Γαλλία' },
  {
    label: 'Γαλλικά Νότια και Ανταρκτικά Εδάφη',
    value: 'Γαλλικά Νότια και Ανταρκτικά Εδάφη',
  },
  { label: 'Γαλλική Γουιάνα', value: 'Γαλλική Γουιάνα' },
  { label: 'Γαλλική Πολυνησία', value: 'Γαλλική Πολυνησία' },
  { label: 'Γερμανία', value: 'Γερμανία' },
  { label: 'Γεωργία', value: 'Γεωργία' },
  { label: 'Γιβραλτάρ', value: 'Γιβραλτάρ' },
  { label: 'Γκάμπια', value: 'Γκάμπια' },
  { label: 'Γκαμπόν', value: 'Γκαμπόν' },
  { label: 'Γκάνα', value: 'Γκάνα' },
  { label: 'Γκέρνσεϊ', value: 'Γκέρνσεϊ' },
  { label: 'Γκουάμ', value: 'Γκουάμ' },
  { label: 'Γουαδελούπη', value: 'Γουαδελούπη' },
  { label: 'Γουατεμάλα', value: 'Γουατεμάλα' },
  { label: 'Γουιάνα', value: 'Γουιάνα' },
  { label: 'Γουινέα', value: 'Γουινέα' },
  { label: 'Γουινέα-Μπισσάου', value: 'Γουινέα-Μπισσάου' },
  { label: 'Γρενάδα', value: 'Γρενάδα' },
  { label: 'Γροιλανδία', value: 'Γροιλανδία' },
  { label: 'Δανία', value: 'Δανία' },
  { label: 'Δομινικανή Δημοκρατία', value: 'Δομινικανή Δημοκρατία' },
  { label: 'Δυτική Όχθη', value: 'Δυτική Όχθη' },
  { label: 'Δυτική Σαχάρα', value: 'Δυτική Σαχάρα' },
  { label: 'Ελ Σαλβαδόρ', value: 'Ελ Σαλβαδόρ' },
  { label: 'Ελβετία', value: 'Ελβετία' },
  { label: 'Ερυθραία', value: 'Ερυθραία' },
  { label: 'Εσθονία', value: 'Εσθονία' },
  { label: 'Ζάμπια', value: 'Ζάμπια' },
  { label: 'Ζιμπάμπουε', value: 'Ζιμπάμπουε' },
  { label: 'Ηνωμένα Αραβικά Εμιράτα', value: 'Ηνωμένα Αραβικά Εμιράτα' },
  {
    label: 'Ηνωμένες Πολιτείες Αμερικής',
    value: 'Ηνωμένες Πολιτείες Αμερικής',
  },
  {
    label: 'Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών',
    value: 'Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών',
  },
  { label: 'Ηνωμένο Βασίλειο', value: 'Ηνωμένο Βασίλειο' },
  { label: 'Ιαπωνία', value: 'Ιαπωνία' },
  { label: 'Ινδία', value: 'Ινδία' },
  { label: 'Ινδονησία', value: 'Ινδονησία' },
  { label: 'Ιορδανία', value: 'Ιορδανία' },
  { label: 'Ιράκ', value: 'Ιράκ' },
  { label: 'Ιράν', value: 'Ιράν' },
  { label: 'Ιρλανδία', value: 'Ιρλανδία' },
  { label: 'Ισημερινή Γουινέα', value: 'Ισημερινή Γουινέα' },
  { label: 'Ισημερινός', value: 'Ισημερινός' },
  { label: 'Ισλανδία', value: 'Ισλανδία' },
  { label: 'Ισπανία', value: 'Ισπανία' },
  { label: 'Ισραήλ', value: 'Ισραήλ' },
  { label: 'Ιταλία', value: 'Ιταλία' },
  { label: 'Καζακστάν', value: 'Καζακστάν' },
  { label: 'Καμερούν', value: 'Καμερούν' },
  { label: 'Καμπότζη', value: 'Καμπότζη' },
  { label: 'Καναδάς', value: 'Καναδάς' },
  { label: 'Κατάρ', value: 'Κατάρ' },
  {
    label: 'Κεντροαφρικανική Δημοκρατία',
    value: 'Κεντροαφρικανική Δημοκρατία',
  },
  { label: 'Κένυα', value: 'Κένυα' },
  { label: 'Κίνα', value: 'Κίνα' },
  { label: 'Κιργιζία', value: 'Κιργιζία' },
  { label: 'Κιριμπάτι', value: 'Κιριμπάτι' },
  { label: 'Κογκό', value: 'Κογκό' },
  { label: 'Κολομβία', value: 'Κολομβία' },
  { label: 'Κομόρες', value: 'Κομόρες' },
  { label: 'Κόστα Ρίκα', value: 'Κόστα Ρίκα' },
  { label: 'Κούβα', value: 'Κούβα' },
  { label: 'Κουβέιτ', value: 'Κουβέιτ' },
  { label: 'Κουρασάο', value: 'Κουρασάο' },
  { label: 'Κροατία', value: 'Κροατία' },
  { label: 'Κύπρος', value: 'Κύπρος' },
  { label: 'Λαϊκή Δημοκρατία του Κογκό', value: 'Λαϊκή Δημοκρατία του Κογκό' },
  { label: 'Λάος', value: 'Λάος' },
  { label: 'Λεσότο', value: 'Λεσότο' },
  { label: 'Λεττονία', value: 'Λεττονία' },
  { label: 'Λευκορωσία', value: 'Λευκορωσία' },
  { label: 'Λίβανος', value: 'Λίβανος' },
  { label: 'Λιβερία', value: 'Λιβερία' },
  { label: 'Λιβύη', value: 'Λιβύη' },
  { label: 'Λιθουανία', value: 'Λιθουανία' },
  { label: 'Λίχτενσταϊν', value: 'Λίχτενσταϊν' },
  { label: 'Λουξεμβούργο', value: 'Λουξεμβούργο' },
  { label: 'Μαγιότ', value: 'Μαγιότ' },
  { label: 'Μαδαγασκάρη', value: 'Μαδαγασκάρη' },
  { label: 'Μακάο', value: 'Μακάο' },
  { label: 'Μαλαισία', value: 'Μαλαισία' },
  { label: 'Μαλάουι', value: 'Μαλάουι' },
  { label: 'Μαλδίβες', value: 'Μαλδίβες' },
  { label: 'Μάλι', value: 'Μάλι' },
  { label: 'Μάλτα', value: 'Μάλτα' },
  { label: 'Μαρόκο', value: 'Μαρόκο' },
  { label: 'Μαρτινίκα', value: 'Μαρτινίκα' },
  { label: 'Μαυρίκιος', value: 'Μαυρίκιος' },
  { label: 'Μαυριτανία', value: 'Μαυριτανία' },
  { label: 'Μαυροβούνιο', value: 'Μαυροβούνιο' },
  { label: 'Μεξικό', value: 'Μεξικό' },
  { label: 'Μιανμάρ', value: 'Μιανμάρ' },
  { label: 'Μογγολία', value: 'Μογγολία' },
  { label: 'Μοζαμβίκη', value: 'Μοζαμβίκη' },
  { label: 'Μολδαβία', value: 'Μολδαβία' },
  { label: 'Μονακό', value: 'Μονακό' },
  { label: 'Μοντσερράτ', value: 'Μοντσερράτ' },
  { label: 'Μπανγκλαντές', value: 'Μπανγκλαντές' },
  { label: 'Μπαρμπάντος', value: 'Μπαρμπάντος' },
  { label: 'Μπαχάμες', value: 'Μπαχάμες' },
  { label: 'Μπαχρέιν', value: 'Μπαχρέιν' },
  { label: 'Μπελίζ', value: 'Μπελίζ' },
  {
    label: 'Μποναίρ, Άγιος Ευστάθιος και Σάμπα',
    value: 'Μποναίρ, Άγιος Ευστάθιος και Σάμπα',
  },
  { label: 'Μποτσουάνα', value: 'Μποτσουάνα' },
  { label: 'Μπουρκίνα Φάσο', value: 'Μπουρκίνα Φάσο' },
  { label: 'Μπουρούντι', value: 'Μπουρούντι' },
  { label: 'Μπουτάν', value: 'Μπουτάν' },
  { label: 'Μπρουνέι', value: 'Μπρουνέι' },
  { label: 'Ναμίμπια', value: 'Ναμίμπια' },
  { label: 'Ναουρού', value: 'Ναουρού' },
  { label: 'Νέα Ζηλανδία', value: 'Νέα Ζηλανδία' },
  { label: 'Νέα Καληδονία', value: 'Νέα Καληδονία' },
  { label: 'Νεπάλ', value: 'Νεπάλ' },
  { label: 'Μπουβέ', value: 'Μπουβέ' },
  { label: 'Νησί Νόρφολκ', value: 'Νησί Νόρφολκ' },
  { label: 'Νήσος των Χριστουγέννων', value: 'Νήσος των Χριστουγέννων' },
  { label: 'Νησιά Κόκος (Keeling)', value: 'Νησιά Κόκος (Keeling)' },
  { label: 'Ώλαντ', value: 'Ώλαντ' },
  { label: 'Βόρειες Μαριάνες Νήσοι', value: 'Βόρειες Μαριάνες Νήσοι' },
  { label: 'Νήσοι Μάρσαλ', value: 'Νήσοι Μάρσαλ' },
  { label: 'Νησιά Πίτκερν', value: 'Νησιά Πίτκερν' },
  { label: 'Κέιμαν Νήσοι', value: 'Κέιμαν Νήσοι' },
  { label: 'Νήσοι Κουκ', value: 'Νήσοι Κουκ' },
  { label: 'Νήσοι Σολομώντα', value: 'Νήσοι Σολομώντα' },
  { label: 'Νήσοι Φερόες', value: 'Νήσοι Φερόες' },
  { label: 'Νήσοι Φώκλαντ', value: 'Νήσοι Φώκλαντ' },
  { label: 'Νήσος Μαν', value: 'Νήσος Μαν' },
  {
    label: 'Νήσοι Χερντ και Μακντόναλντ',
    value: 'Νήσοι Χερντ και Μακντόναλντ',
  },
  { label: 'Νίγηρας', value: 'Νίγηρας' },
  { label: 'Νιγηρία', value: 'Νιγηρία' },
  { label: 'Νικαράγουα', value: 'Νικαράγουα' },
  { label: 'Νιούε', value: 'Νιούε' },
  { label: 'Νορβηγία', value: 'Νορβηγία' },
  { label: 'Νότια Αφρική', value: 'Νότια Αφρική' },
  {
    label: 'Νήσοι Νότια Γεωργία και Νότιες Σάντουιτς',
    value: 'Νήσοι Νότια Γεωργία και Νότιες Σάντουιτς',
  },
  { label: 'Νότια Κορέα', value: 'Νότια Κορέα' },
  { label: 'Νότιο Σουδάν', value: 'Νότιο Σουδάν' },
  { label: 'Δομινίκα', value: 'Δομινίκα' },
  { label: 'Ολλανδία (Κάτω Χώρες)', value: 'Ολλανδία (Κάτω Χώρες)' },
  { label: 'Ολλανδικές Αντίλλες', value: 'Ολλανδικές Αντίλλες' },
  { label: 'Ομάν', value: 'Ομάν' },
  {
    label: 'Ομόσπονδες Πολιτείες της Μικρονησίας',
    value: 'Ομόσπονδες Πολιτείες της Μικρονησίας',
  },
  { label: 'Ονδούρα', value: 'Ονδούρα' },
  { label: 'Ουαλίς και Φουτουνά', value: 'Ουαλίς και Φουτουνά' },
  { label: 'Ουγγαρία', value: 'Ουγγαρία' },
  { label: 'Ουγκάντα', value: 'Ουγκάντα' },
  { label: 'Ουζμπεκιστάν', value: 'Ουζμπεκιστάν' },
  { label: 'Ουκρανία', value: 'Ουκρανία' },
  { label: 'Ουρουγουάη', value: 'Ουρουγουάη' },
  { label: 'Πακιστάν', value: 'Πακιστάν' },
  { label: 'Παλάου', value: 'Παλάου' },
  { label: 'Παναμάς', value: 'Παναμάς' },
  { label: 'Παπούα Νέα Γουινέα', value: 'Παπούα Νέα Γουινέα' },
  { label: 'Παραγουάη', value: 'Παραγουάη' },
  {
    label: 'Αμερικανικές Παρθένοι Νήσοι',
    value: 'Αμερικανικές Παρθένοι Νήσοι',
  },
  { label: 'Βόρεια Μακεδονία', value: 'Βόρεια Μακεδονία' },
  { label: 'Περού', value: 'Περού' },
  { label: 'Πολωνία', value: 'Πολωνία' },
  { label: 'Πορτογαλία', value: 'Πορτογαλία' },
  { label: 'Πουέρτο Ρίκο', value: 'Πουέρτο Ρίκο' },
  { label: 'Πράσινο Ακρωτήρι', value: 'Πράσινο Ακρωτήρι' },
  { label: 'Ρεϊνιόν', value: 'Ρεϊνιόν' },
  { label: 'Ρουάντα', value: 'Ρουάντα' },
  { label: 'Ρουμανία', value: 'Ρουμανία' },
  { label: 'Ρωσία', value: 'Ρωσία' },
  { label: 'Σαμόα', value: 'Σαμόα' },
  { label: 'Νήσος Αγίας Ελένης', value: 'Νήσος Αγίας Ελένης' },
  { label: 'Σάο Τομέ και Πρίνσιπε', value: 'Σάο Τομέ και Πρίνσιπε' },
  { label: 'Σαουδική Αραβία', value: 'Σαουδική Αραβία' },
  { label: 'Σβάλμπαρντ', value: 'Σβάλμπαρντ' },
  { label: 'Σενεγάλη', value: 'Σενεγάλη' },
  { label: 'Σερβία', value: 'Σερβία' },
  { label: 'Σεϋχέλλες', value: 'Σεϋχέλλες' },
  { label: 'Σιέρα Λεόνε', value: 'Σιέρα Λεόνε' },
  { label: 'Σιγκαπούρη', value: 'Σιγκαπούρη' },
  { label: 'Σλοβακία', value: 'Σλοβακία' },
  { label: 'Σλοβενία', value: 'Σλοβενία' },
  { label: 'Σομαλία', value: 'Σομαλία' },
  { label: 'Εσουατίνι', value: 'Εσουατίνι' },
  { label: 'Σουδάν', value: 'Σουδάν' },
  { label: 'Σουηδία', value: 'Σουηδία' },
  { label: 'Σουρινάμ', value: 'Σουρινάμ' },
  { label: 'Σρι Λάνκα', value: 'Σρι Λάνκα' },
  { label: 'Συρία', value: 'Συρία' },
  { label: 'Ταϊβάν', value: 'Ταϊβάν' },
  { label: 'Ταϊλάνδη', value: 'Ταϊλάνδη' },
  { label: 'Τανζανία', value: 'Τανζανία' },
  { label: 'Τατζικιστάν', value: 'Τατζικιστάν' },
  { label: 'Τερκς και Κέικος', value: 'Τερκς και Κέικος' },
  { label: 'Τζαμάικα', value: 'Τζαμάικα' },
  { label: 'Τζέρσεϊ', value: 'Τζέρσεϊ' },
  { label: 'Τζιμπουτί', value: 'Τζιμπουτί' },
  { label: 'Τόγκα', value: 'Τόγκα' },
  { label: 'Τόγκο', value: 'Τόγκο' },
  { label: 'Τοκελάου', value: 'Τοκελάου' },
  { label: 'Τουβαλού', value: 'Τουβαλού' },
  { label: 'Τουρκία', value: 'Τουρκία' },
  { label: 'Τουρκμενιστάν', value: 'Τουρκμενιστάν' },
  { label: 'Τρινιντάντ και Τομπάγκο', value: 'Τρινιντάντ και Τομπάγκο' },
  { label: 'Τσαντ', value: 'Τσαντ' },
  { label: 'Τσεχία', value: 'Τσεχία' },
  { label: 'Τυνησία', value: 'Τυνησία' },
  { label: 'Υεμένη', value: 'Υεμένη' },
  { label: 'Φιλιππίνες', value: 'Φιλιππίνες' },
  { label: 'Φινλανδία', value: 'Φινλανδία' },
  { label: 'Φίτζι', value: 'Φίτζι' },
  { label: 'Χιλή', value: 'Χιλή' },
  { label: 'Χονγκ Κονγκ', value: 'Χονγκ Κονγκ' },
];
